import { TextConfigurationItem } from '../types-store';

export const hasChanges = (textItem: TextConfigurationItem, original: TextConfigurationItem): boolean => {

  if ((textItem && textItem.id) !== (original && original.id)) {
    return true;
  }

  if ((textItem && textItem.textSet && textItem.textSet.value) !==
    (original && original.textSet && original.textSet.value)) {
    return true;
  }

  const textCollection = (textItem || {}).textCollection || [];
  const originalTextCollection = (original || {}).textCollection || [];

  if (textCollection.length !== originalTextCollection.length) {
    return true;
  }

  if (textCollection.some(
    collection => !originalTextCollection.some(
      originalCollection => collection.value === originalCollection.value
    ))) {
    return true;
  }

  const translations = ((textItem ?? {}).translations ?? [])
    .filter(languageItem => (languageItem.text ?? '').trim().length > 0
      || (languageItem.originalText ?? '').trim().length > 0);
  const originalTranslations = ((original ?? {}).translations ?? [])
    .filter(languageItem => (languageItem.text ?? '').trim().length > 0
      || (languageItem.originalText ?? '').trim().length > 0);

  if (translations.length !== originalTranslations.length) {
    return true;
  }

  if (translations.some(
    translation => !originalTranslations.some(
      originalTranslation => translation.language === originalTranslation.language &&
        (translation.text ?? '') === (originalTranslation.text ?? '') &&
        (translation.originalText ?? '') === (originalTranslation.originalText ?? ''))
  )) {
    return true;
  }

  return false;
};
